var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyRadioIcon = function SvgEmptyRadioIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D6D6D6",
    d: "M11.998 3.5q1.873.001 3.508.707a9.1 9.1 0 0 1 2.861 1.925 9 9 0 0 1 1.74 2.455l.186.405q.706 1.634.707 3.506a8.8 8.8 0 0 1-.707 3.508 9.1 9.1 0 0 1-1.925 2.861 9 9 0 0 1-2.455 1.74l-.405.186a8.75 8.75 0 0 1-3.506.707 8.8 8.8 0 0 1-3.508-.707 9.1 9.1 0 0 1-2.861-1.925 9 9 0 0 1-1.74-2.455l-.186-.405A8.75 8.75 0 0 1 3 12.502q.001-1.873.707-3.508a9.1 9.1 0 0 1 1.925-2.861 9 9 0 0 1 2.455-1.74l.405-.186a8.75 8.75 0 0 1 3.506-.707Z"
  })));
};
export default SvgEmptyRadioIcon;